<template>
	<div id="app">
		<div v-if="!cssLoaded" id="loading-spinner" />
		<router-view/>
		<environment-switcher v-if="useAcceptance" :current-environment="currentEnvironment" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import EnvironmentSwitcher from '../src/components/Shared/EnvironmentSwitcher';
import { getFormattedEnvironmentCookie } from '../src/shared/utils/cookieHelper';

export default {
	name: 'App',
	components: {
		EnvironmentSwitcher
	},
	data() {
		return {
			currentEnvironment: ''
		};
	},
	computed: {
		...mapGetters([
			'getEnvironment',
			'cssLoaded'
		]),
		useAcceptance() {
			const environment = this.getEnvironment;
			return environment !== 'production';
		}
	},
	beforeMount() {
		const useAcceptance = this.useAcceptance;
		// Environment switcher
		// Usable with the same environment switcher as American Funds code base
		const environmentCookie = getFormattedEnvironmentCookie();

		if (environmentCookie) {
			this.currentEnvironment = useAcceptance
				? environmentCookie
				: 'prodLive';
			this.$store.commit('updateStagingFlag', this.currentEnvironment);
		} else {
			this.currentEnvironment = useAcceptance
				? this.$store.state.stagingFlag
				: 'prodLive';
		}
	},

	mounted() {
		try {
			setTimeout(() => {
				try {
					this.$store.commit('cssLoaded', true);
					// const methodParams = { params: this.$store.state.appConfig.context, name: this.$route.name };
				} catch (e) {
					//eslint-disable-next-line no-console
					console.log(e.message);
				}
			}, 1000);
			const t = setInterval(() => {
				if (
					document.readyState === 'complete' &&
					$('#client-content-footer').length > 0
				) {
					const promises = [];

					$('#client-content-header, #client-content-footer')
						.find('script[src]')
						.each((index, script) => {
							const scriptSrc = script.src;

							if (
								scriptSrc &&
								scriptSrc.indexOf('f2apps') < 0 &&
								scriptSrc.indexOf('f2.debug') < 0 &&
								scriptSrc.indexOf('jquery.min.js') < 0 &&
								scriptSrc.indexOf('foot-dtm') < 0
							) {
								promises.push(
									$.ajax({
										url: scriptSrc,
										dataType: 'script',
										async: false,
										cache: true
									})
								);
							}
						});

					Promise.all(promises)
						// eslint-disable-next-line no-console
						.catch(err => console.warn(err));
					clearInterval(t);
				}
			}, 500);
		} catch (err) {
			console.log(err);
		}
	}
};
</script>

<style lang='less'>
@import 'floating-vue/dist/style.css';
@import 'assets/css/fonts.css';
@import 'assets/css/common.css';
@import 'assets/css/bootstrap.min.css';
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	#popper-boundary {
		pointer-events: none;
		position: fixed;
		z-index: 1001;
	}
}
</style>
<style>
@import '~_componentLibraryDist_/cg-components.css';
@import '~_componentLibraryDist_/css/stylesheet.css';
@import '_AFIS_/../icomoon/icon-style.css';
</style>
